import {
    type FC
} from "react";
import type IDataTableExportProps from "./type";
import {
    NCoreUIKitLocalize,
    NCoreUIKitTheme
} from "../../../../core/hooks";
import type {
    NCoreUIKitIcon
} from "../../../../types";
import {
    useDataTableSelectionContext,
    useDataTableContext
} from "../../context";
import {
    Download as DownloadIcon
} from "lucide-react-native";
import {
    downloadDataTableCsv,
    getDataTableCsv
} from "../../util";
import Button from "../../../button";

const DataTableExport: FC<IDataTableExportProps> = ({
    customTheme: customThemeProp,
    fileName = "export",
    variant = "outline",
    scope = "auto",
    onExport,
    style,
    title
}) => {
    const context = useDataTableContext({
        part: "Export"
    });

    const selectionContext = useDataTableSelectionContext();

    const {
        colors
    } = NCoreUIKitTheme.useContext(customThemeProp ?? context?.customTheme);

    const {
        localize
    } = NCoreUIKitLocalize.useContext(context?.customLocalize);

    if(!context) {
        return null;
    }

    const handlePress = () => {
        const currentScope = scope === "auto" ? ((selectionContext?.selectedRowIds.length ?? 0) > 0 ? "selected" : "filtered") : scope;

        const exportData = context.getExportData(currentScope);

        const csv = getDataTableCsv(exportData);

        if(onExport) {
            onExport({
                ...exportData,
                scope: currentScope,
                fileName,
                csv
            });

            return;
        }

        downloadDataTableCsv({
            fileName,
            csv
        });
    };

    const renderIcon: NCoreUIKitIcon = ({
        customColor,
        color,
        size
    }) => <DownloadIcon
        color={customColor ?? colors.content.icon[color]}
        size={size}
    />;

    return <Button
        isDisabled={context.isPermissionDenied || context.isLoading || context.totalCount === 0}
        customTheme={customThemeProp ?? context.customTheme}
        title={title ?? localize("data-table-export")}
        onPress={handlePress}
        icon={renderIcon}
        variant={variant}
        type="neutral"
        style={style}
        size="small"
    />;
};
export default DataTableExport;
